import React from 'react';
import PropTypes from 'prop-types';

const AppfolioInfo = ({ integration: { vendor, role, username, password, appfolio_property_id } }) => (
  <div className="knock-admin-integration-info">
    <div>
      <strong>Integration:</strong> {vendor}
      {role === 'import' ? ' (unit availability, resident import)' : ''}
    </div>
    <div>
      <strong>Username:</strong> {username}
    </div>
    <div>
      <strong>Password:</strong> {password}
    </div>
    <div>
      <strong>Appfolio Property ID:</strong> {appfolio_property_id}
    </div>
  </div>
);

AppfolioInfo.propTypes = {
  integration: PropTypes.object
};

export default AppfolioInfo;
